import { MouseEvent, useState } from 'react';
import { Avatar, Box, Button, Popover } from '@mui/material';

import type { UserProfilePublic } from './userTypes';

type UserProps = {
    user: UserProfilePublic;
    signout: (e: MouseEvent<HTMLElement>) => void;
};

export const User = ({ user, signout }: UserProps) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    return (
        <>
            <Box
                onClick={(e) => {
                    setAnchorEl(e.currentTarget);
                }}
                sx={{ marginRight: 2, cursor: 'pointer' }}
            >
                <Avatar
                    src={user.photo || undefined}
                    alt="User profile picture"
                >
                    {!user.photo &&
                        user.displayName.substring(0, 2).toLocaleUpperCase()}
                </Avatar>
            </Box>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                onClose={() => setAnchorEl(null)}
            >
                <Box sx={{ padding: 1, width: 350 }}>
                    <p>{user.email}</p>
                    <p>Access level:</p>
                    <ul>
                        {user.roles.map((role) => (
                            <li key={role}>{role}</li>
                        ))}
                    </ul>

                    <Button type="button" onClick={signout} variant="contained">
                        Logout
                    </Button>
                </Box>
            </Popover>
        </>
    );
};
